import { render, staticRenderFns } from "./recommendWordDetail.vue?vue&type=template&id=c36867a8&scoped=true&"
import script from "./recommendWordDetail.vue?vue&type=script&lang=js&"
export * from "./recommendWordDetail.vue?vue&type=script&lang=js&"
import style0 from "./recommendWordDetail.vue?vue&type=style&index=0&id=c36867a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36867a8",
  null
  
)

export default component.exports